<template>
  <div class="admin__home">
    <OnboardHeader />
    <div class="admin__home--left-div">
      <OnboardSidebar :item="item" />
    </div>
    <div class="admin__home--right-div"></div>
  </div>
</template>

<script>
import OnboardHeader from "../../partials/onboardHeader";
import OnboardSidebar from "../../partials/onboardSidebar";

export default {
  name: "OnboardPayroll",
  components: {
    OnboardHeader,
    OnboardSidebar
  }
};
</script>
<style lang="scss" scoped>
.overview {
  width: 400px;
  margin: auto;
  text-align: center;

  > h3 {
    font-size: 1.042vw;
  }
}
</style>

